<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="lot && program && !loading">
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <div slot="left">
          <h1 class="title is-4">
            <span v-if="program" class="has-text-weight-normal is-uppercase">
              <router-link :to="{name: 'ProgramVue', params: {id: lot.program}}">
                {{program.name | cap}} /
              </router-link>
            </span>
            <span v-if="!isParking" class="has-text-weight-medium">Lot {{lot.ref}}</span>
            <span v-else class="has-text-weight-medium">Parking {{lot.ref}}</span>
            <router-link :to="{name:'PromoteurVue', params: {id: lot.promoteur}}"
                         v-if="isDistributeurMode && (isAdmin || isEditor) && lot.promoteur && lot.promoteur_name"
                         class="has-text-weight-light has-text-grey"> - {{lot.promoteur_name}}
            </router-link>
            <span v-else-if="!isExternal && isDistributeurMode"> - {{lot.promoteur_name}}</span>
          </h1>
        </div>
        <div class="column is-paddingless is-border-left" slot="left-action" v-if="canBeDenunce">
          <a @click="openDenunciationVue" class="page-header-btn is-small"
            :disabled="!canBeDenunce">
            <span class="icon"><i class="fas fa-bullhorn"></i></span><span>Dénoncer contact</span>
          </a>
        </div>
        <div class="column is-paddingless is-border-left" slot="left-action" v-if="canBeOptioned && program.is_optionable">
          <a @click="openOptionModal" :disabled="!canBeOptioned"
            class="page-header-btn is-small is-primary">
            <span class="icon"><i class="fas fa-flag"></i></span>
            <span>Poser option</span>
          </a>
        </div>
        <router-link :to="{name: isParking ? 'ParkingEdit' : 'LotEdit', params: {id: lot.pk}}" class="dropdown-item"
                     v-if="(isAdmin || isEditor) && !['sold', 'reserved'].includes(lot.status)"
                     slot="dropdown-content">
          <span class="icon"><i class="fas fa-edit"></i></span>
          <span v-if="isParking">Modifier fiche parking</span>
          <span v-else>Modifier fiche lot</span>
        </router-link>
        <router-link :to="{name: isParking ? 'ParkingCreate' : 'LotCreate', query: {duplicateLot: lot.pk}}" class="dropdown-item"
                     v-if="(isAdmin || isEditor) && !lot.from_flux && !isParking"
                     slot="dropdown-content">
          <span class="icon"><i class="fas fa-clone"></i></span><span>Dupliquer</span>
        </router-link>
        <router-link :to="{name: 'LotEdit', params: {id: lot.pk}, query: {panel: 'DOCS'}}" class="dropdown-item"
                     v-if="(isAdmin || isEditor) && !['sold', 'reserved'].includes(lot.status) && !isParking"
                     slot="dropdown-content">
          <span class="icon"><i class="fas fa-folders"></i></span><span>Gestion documents</span>
        </router-link>
        <router-link :to="{name: 'ParkingEdit', params: {id: lot.pk}, query: {panel: 'DOCS'}}" class="dropdown-item"
                     v-else-if="(isAdmin || isEditor) && !['sold', 'reserved'].includes(lot.status)"
                     slot="dropdown-content">
          <span class="icon"><i class="fas fa-folders"></i></span><span>Gestion documents</span>
        </router-link>


        <!-- <a @click.prevent.stop="lockLot(lot.pk, true)" class="dropdown-item"
           v-if="!lot.locked"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-trash"></i></span><span>Bloquer le lot</span>
        </a>
        <a @click.prevent.stop="lockLot(lot.pk)" class="dropdown-item"
           v-if="lot.locked"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-trash"></i></span><span>Débloquer le lot</span>
        </a> -->
        <a @click.prevent.stop="addToWishlist" class="dropdown-item"
           v-if="!wishlisted" slot="dropdown-content">
          <span class="icon"><i class="fal fa-star"></i></span><span>Ajouter aux favoris</span>
        </a>
        <a @click.prevent.stop="deleteFromWishlist" class="dropdown-item"
           v-if="wishlisted" slot="dropdown-content">
          <span class="icon"><i class="fas fa-star"></i></span><span>Supprimer des favoris</span>
        </a>
        <!-- <router-link :to="{name: 'ExternalEdit', params: {id: lot.pk}}" class="dropdown-item"
                     v-if="isAdmin && canBeSold && isDistributeurMode" slot="dropdown-content">
          <span class="icon"><i class="fas fa-handshake"></i></span><span>Vente externe</span>
        </router-link> -->
        <a @click.prevent.stop="deleteExternalSale" class="dropdown-item"
           v-if="isAdmin && externalSale && isSold"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-eraser"></i></span><span>Supprimer la vente externe</span>
        </a>
        <a v-if="isAdmin" @click="xlsExportUrl" class="dropdown-item"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-file-export"></i></span><span>Exporter données .XLS</span>
        </a>
        <a @click.prevent.stop="deleteLot" class="dropdown-item has-text-danger"
           v-if="isAdmin && canBeDeleted"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-trash-alt"></i></span><span>Supprimer lot</span>
        </a>
      </sticky>
      <div class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions has-stickyColumn has-stickyColumn--left" id="columns-collapse">
        <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
          <div class="card has-bg-white is-bordered">
            <div class="columns is-vcentered has-status-bar--left" :class="[statusBarColor]">
              <div class="column is-padding-top-small is-padding-bottom-small">
                <span class="has-text-primary is-inline-block is-vcentered has-text-weight-bold">Statut du lot :</span>
                <div class="control is-inline-block is-vcentered ">
                  <div class="select is-transparent is-small is-pulled-left" v-if="canChangeStatus">
                    <select v-model="lot.status" @change="updateStatus" class="is-paddingless-left">
                      <option v-for="s in statusLotList" :value="s.value" :key="s.value">{{s.label}}</option>
                    </select>
                  </div>
                  <div v-else class="is-size-6">
                    {{lot.status | statusLabel}}
                  </div>
                </div>
                <div class="control is-margin-top-small is-size-6" v-if="isAdmin || isEditor">
                  <i>Visible par : {{accessSellersCount}} Vendeurs(s) / {{accessExternalSellersCount}} Prescripteur(s)</i>
                </div>
              </div>
            </div>
            <div v-if="program && program.pictures.length && program.pictures.length > 0">
              <figure class="image is-margin-auto has-tag has-tag--top-left">
                <span v-if="program && isAdmin" class="tag is-radiusless" :class="statusColor">{{program.status | workflowLabel}}</span>
                <div>
                  <img class="" alt=""
                       :src="program.pictures[0].cloudinary_id | cloudinary({width: 300, height: 175, crop: 'fill'})">
                </div>
              </figure>
            </div>

            <div class="columns is-multiline is-border-top is-border-dashed">
              <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}"
                tag="div"
                class="column is-12 columns is-column is-padding-top-small is-padding-bottom-small is-space-between graph-over graph-over--decoration">
                <div class="has-text-grey is-size-6">Programme</div>
                <span>
                  <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}" class="has-text-primary is-size-4">{{program.name}}</router-link>
                  <span class="icon has-text-black tooltip is-tooltip-right is-padding-left-xsmall is-size-5"
                      data-tooltip="Flux promoteur" v-if="isDistributeurMode && program.from_flux && !isExternal">
                    <i class="fas fa-rss"></i>
                  </span>
                </span>
                <div class="is-margin-top-xsmall">
                  <span v-if="program.progress_step" class="tag is-info">{{programStepProgressLabel(program.progress_step)}}</span>
                </div>
              </router-link>
              <div class="column is-12 columns is-column is-padding-top-small is-padding-bottom-small is-space-between is-border-top is-border-dashed"
                   v-if="address && Object.values(address).length" v-scroll-to="'#mapVue'">
                <div class="has-text-grey is-size-6">Adresse</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-5">{{address.line1}}<br>{{address.zip_code}}
                  {{address.city}}
                  <br>
                  <span v-if="address.country.trim().toLowerCase() !== 'france'"><i>{{address.country}}</i></span>
                </div>
                <!--<div class="is-size-6">
                    <a class="is-underline"><i>Voir sur la carte</i></a>
                </div>-->
              </div>
              <div v-if="!isParking && $configs && $configs.COUNTRY === 'FRA'" class="column is-6 is-border-right is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <div class="has-text-grey is-size-6">Dispositif(s)</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-if="taxDispositifs">{{taxDispositifs}}</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-else>Aucun</div>
              </div>
              <div v-if="$configs && $configs.COUNTRY === 'FRA'"
                class="column is-6 is-border-top columns is-column is-border-dashed is-padding-top-small is-padding-bottom-small is-space-between">
                <span class="has-text-grey is-size-6">Zone</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4 is-uppercase" v-if="program.tax_zone">{{program.tax_zone}}</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</span>
              </div>
              <div class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <div class="has-text-grey is-size-6">{{actabilityTerm}}</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4"
                     v-if="program && program.date_actabilite">{{program.date_actabilite | prettyTrimestre}}
                </div>
                <div v-else>--</div>
              </div>
              <div
                class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <div class="has-text-grey is-size-6">Livraison</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4"
                     v-if="program && program.date_livraison">{{program.date_livraison | prettyTrimestre}}
                </div>
                <div v-else>--</div>
              </div>
              <div class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between graph-over graph-over--decoration"
                    @click="goToLotsList" v-if="program">
                <div class="has-text-grey is-size-6">Lot(s) disponible(s)</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">{{(filteredLogement.length || 0) + (filteredParking.length || 0)}}</div>
              </div>
              <div class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between"
                   v-if="isExternal && access && access.remuneration && displayRemuneration">
                <div class="has-text-grey is-size-6">Taux commercialisation</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">{{access.remuneration|prettyPrice}}%</div>
              </div>
              <div class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between"
                   v-else-if="!isExternal && displayRemuneration">
                <div class="has-text-grey is-size-6">Taux commercialisation</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-if="program && program.remuneration">
                  {{program.remuneration|prettyPrice}}%
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</div>
              </div>
            </div>
          </div>
          <div v-if="isAdmin && events && events.length> 0">
            <event-tracker-list v-if="isAdmin" :show-list="showLastEvents" :events="lastEvents" :last-event="lastEvent"
                                :show-all="!!fullHistory && !!fullHistory.length"
                                @showAll="getFullHistory"
                                @toggle="showLastEvents = !showLastEvents">
            </event-tracker-list>
          </div>
        </div>

        <div class="column is-8 is-9-fullhd is-paddingless-right">

          <lot-status-notifications v-if="!optionLoading && !loading"
                                    :external-sale="externalSale"
                                    :adv="adv"
                                    :from-option="fromOption"
                                    :user-pending-option="userPendingOption"
                                    :first-option="firstOption"
                                    :waiting-list="waitingList"
                                    :pending-options="pendingOptions"
                                    :lot="lot"
                                    :loading="loadingOptionAction"
                                    @updateOption="updateOption"
          ></lot-status-notifications>

          <div class="has-bg-white is-border is-padding-bottom-xsmall">
            <div class="is-padding-right-large is-padding-left-large is-padding-top is-padding-bottom columns is-gapless is-vcentered">
                <!-- <div class="is-margin-right-xsmall column is-narrow" v-if="lot.locked && isAdmin">
                  <span class="icon is-medium has-text-grey tooltip is-tooltip-top is-size-4" data-tooltip="Bloqué" >
                    <i class="fas fa-lock-alt"></i>
                  </span>
                </div> -->
                <div class="column is-narrow">
                    <div class="title is-3 is-uppercase">
                      <span class="has-text-grey">N° du lot :</span>
                      <b>{{lot.ref}} - Prix : <span v-if="lot.sale_price" >{{lot.sale_price | prettyPrice}} {{$currency}}</span><i v-else>NC</i></b>
                      <span class="icon has-text-black tooltip is-tooltip-right is-padding-left-xsmall is-size-5"
                          data-tooltip="Flux promoteur" v-if="isDistributeurMode && program.from_flux && !isExternal">
                        <i class="fas fa-rss"></i>
                      </span>
                    </div>
                </div>
                <div class="is-margin-left column columns is-gapless">
                    <div class="column is-narrow">
                      <div class="tags">
                        <span v-for="(t, i) in lot.tags" class="tag is-annonce is-small" :key="i">{{t}}</span>
                      </div>
                    </div>
                </div>
            </div>
            <div class="has-bg-grey2 is-padding-right-large is-padding-left-large is-padding-top-small is-padding-bottom-small is-uppercase">
              <template v-if="$configs && $configs.COUNTRY === 'FRA'">
                <span v-if="!isParking" class="has-text-grey">Dispositif(s) :</span> <strong v-if="taxDispositifs && !isParking">{{taxDispositifs}}</strong><strong v-else-if="!taxDispositifs && !isParking">NC</strong>
                <span v-if="!isParking" class="has-text-grey">/</span>
              </template>
              <span class="has-text-grey">{{actabilityTerm}} :</span>
              <strong v-if="program && program.date_actabilite">{{program.date_actabilite | prettyTrimestre}}</strong>
              <strong v-else>NC</strong>
              <span class="has-text-grey">/ Livraison :</span>
              <strong v-if="program && program.date_livraison">{{program.date_livraison | prettyTrimestre}}</strong>
              <strong v-else>NC</strong>
            </div>
            <div class="columns has-bg-annonce is-vcentered" v-if="program && !program.is_optionable">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
                <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
              </div>
              <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <div class="has-text-white is-italic is-size-7 has-text-weight-bold">
                  <span>Lot non optionnable (contacter responsable programme)</span>
                </div>
              </div>
            </div>
            <div class="columns has-bg-grey1 is-vcentered" v-if="allotment && isAdmin">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall"></div>
              <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <div class="has-text-white is-uppercase is-size-7 has-text-weight-bold">
                  <span>Alloté : {{allotment}} société(s)</span>
                </div>
              </div>
            </div>

            <div class="columns is-gapless is-padding-left-large is-padding-right-large is-padding-top is-padding-bottom is-multiline">
              <div class="column is-4 is-border-right is-border-dashed">
                <h3 v-if="!isParking" class="title is-4 is-margin-bottom-small"><b>Caractéristiques du lot</b></h3>
                <h3 v-else class="title is-4 is-margin-bottom-small"><b>Caractéristiques du Parking</b></h3>
                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Nature et type :
                    <span class="has-text-grey">
                      <span v-if="lot.nature">{{natureLabel(lot.nature)}}</span><i v-else>NC</i>
                      &nbsp;
                      <span v-if="lot.lot_type">{{lotTypeLabel(lot.lot_type)}}</span><i v-else>NC</i>
                    </span>
                  </span>
                </div>
                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Surface :
                    <span class="has-text-grey">
                      <span v-if="lot.surface">{{lot.surface | prettyPrice}} m²</span><i v-else>NC</i>
                    </span>
                  </span>
                </div>
                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Etage :
                    <span class="has-text-grey">
                      <span  v-if="lot.floor">{{lot.floor}}</span><i v-else>NC</i>
                    </span>
                  </span>
                </div>
                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Orientation :
                    <span class="has-text-grey">
                      <span v-if="lot.exposures && lot.exposures.length">{{lot.exposures | exposuresLabel}}</span><i v-else>NC</i>
                    </span>
                  </span>
                </div>
                <div v-if='isParking' class="has-text-weight-medium">
                  <span class="has-text-black">Type : <span class="has-text-grey">Parking/Box/Garage</span></span>
                </div>
              </div>

              <div v-if="!isParking" class="column is-4 is-border-right is-border-dashed is-padding-left-small">
                <h3 class="title is-4 is-margin-bottom-small"><b>Annexe / Parking</b></h3>
                <div class="has-text-weight-medium">
                  <div v-for="(items, type) in annexes" :key="'annex-'+type" v-if="annexes && !!Object.values(annexes).length"
                       class="has-text-grey has-text-weight-medium">
                    <span class="has-text-black" v-if="items.count > 1">{{items.count}}</span>
                    <span class="has-text-black">{{ type | annexTypeLabel | cap | pluralize(items.count > 1) }}</span>
                    <span class="has-text-black" v-if="(items.infos && !!items.infos.length) || items.surface"> : </span>
                    <span v-for="i in items.count" :key="i">
                      <span v-if="items.surface && items.surface[i - 1]">{{items.surface[i - 1]}} m²</span>
                      <span class="has-text-weight-light" v-if="items.infos && !!items.infos[i - 1]">({{items.infos[i - 1]}})</span>
                      <span v-if="items.count > 1 && i !== items.count">/ </span>
                    </span>
                    <!-- <span v-if="items.surface">{{ items.surface.join(' m², ') | prettyPrice}} m²</span>
                    <span class="has-text-weight-light" v-if="items.infos && !!items.infos.length">({{ items.infos.join(', ') }})</span> -->
                  </div>
                  <span class="has-text-black" v-if="parkings && !!parkings.totalCount">
                    {{parkings.totalCount}} Parking(s) :
                  </span>
                  <span v-if="parkings && !!parkings.totalCount" class="has-text-grey has-text-weight-medium" v-for="i in parkings.totalCount" :key="i">
                    <span v-if="parkings.totalCount > 1">{{ parkings.count[i - 1] }}</span>
                    <span>{{ parkings.type[i - 1] | cap }}</span>
                    <span class="has-text-weight-light" v-if="parkings.infos && !!parkings.infos[i - 1]">({{ parkings.infos[i - 1] }})</span>
                    <span v-if="parkings.totalCount > 1 && i !== parkings.totalCount && i <= parkings.count.length - 1">/ </span>
                  </span>
                  <i v-if="(!annexes || !Object.values(annexes).length) && (!parkings || !parkings.totalCount)">NC</i>
                </div>
              </div>

              <div class="column is-4 is-padding-left-small">
                <h3 class="title is-4 is-margin-bottom-small"><b>Prix / Loyer</b></h3>
                <div class="has-text-weight-medium">
                  <span class="has-text-black">Prix immo HT :
                    <span class="has-text-grey">
                      <span v-if="lot.sale_price_ht">
                        {{lot.sale_price_ht | prettyPrice}} {{$currency}}<i class="has-text-weight-light"> (TVA {{lot.sale_price_ht | tva(lot.sale_price) | prettyPrice}} %)</i>
                      </span>
                      <i v-else>NC</i>
                    </span>
                  </span>
                </div>
                <div class="has-text-weight-medium">
                  <span class="has-text-black">Prix immo TTC :
                    <span class="has-text-grey">
                      <span v-if="lot.sale_price">{{lot.sale_price | prettyPrice}} {{$currency}}</span>
                      <i v-else>NC</i>
                    </span>
                  </span>
                </div>

                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Loyer :
                    <span class="has-text-grey">
                      <span v-if="lot.rent">{{lot.rent | prettyPrice}} {{$currency}}</span>
                      <i v-else>NC</i>
                    </span>
                  </span>
                </div>

                <div v-if="!isParking" class="has-text-weight-medium">
                  <span class="has-text-black">Rentabilité :
                    <span class="has-text-grey">
                      <span v-if="lot.profitability">{{lot.profitability|prettyPrice}} %</span>
                      <i v-else>NC</i>
                    </span>
                  </span>
                </div>
              </div>
              <div class="column is-12 is-margin-top" v-if="'description' in lot && lot.description">
                <div class="column content ql-editor is-paddingless">
                  <h3 class="title is-4 is-marginless has-text-black"><b>Description du lot</b></h3>
                  <p v-html="lot.description"></p>
                </div>
              </div>
              <div class="column is-12 is-margin-top" v-if="lot.custom_prices && lot.custom_prices.length"
                    v-for="(customPrice, i) in lot.custom_prices" :key="i">
                <div class="column is-border is-border--grey1 is-radius-large has-bg-light">
                  <h3 class="title is-4 is-marginless-bottom is-uppercase"><b>{{customPrice.name}}</b></h3>
                  <div class="column is-paddingless">
                    <span class="has-text-black is-padding-right"><span class="has-text-weight-medium">Prix immo HT :</span>
                      <span class="has-text-grey">
                        <span v-if="customPrice.sale_price_ht">
                          {{customPrice.sale_price_ht | prettyPrice}} {{$currency}}
                          <i class="has-text-weight-light"> (TVA {{customPrice.sale_price_ht | tva(customPrice.sale_price) | prettyPrice}} %)</i>
                        </span>
                        <i v-else>NC</i>
                      </span>
                    </span>
                    <span class="has-text-black"><span class="has-text-weight-medium">Prix immo TTC :</span>
                      <span class="has-text-grey">
                        <span v-if="customPrice.sale_price">{{customPrice.sale_price | prettyPrice}} {{$currency}}</span>
                        <i v-else>NC</i>
                      </span>
                    </span>
                  </div>
                  <div class="has-text-weight-medium has-text-grey" v-html="customPrice.description"></div>
                </div>
              </div>
              <div v-if="lot.sale_price_less_parking_ht || lot.sale_price_less_parking || lot.capped_profitability || lot.capped_rent" class="column is-12 is-margin-top">
                <h3 class="title is-4 is-margin-bottom-small"><b>Informations complémentaires</b></h3>
                <div class="has-text-weight-medium" v-if="lot.sale_price_less_parking_ht">
                  <span class="has-text-black">Prix immo (hors parking) HT :
                    <span class="has-text-grey">
                      <span>
                        {{lot.sale_price_less_parking_ht | prettyPrice}} {{$currency}}
                        <i class="has-text-weight-light"> (TVA {{lot.sale_price_less_parking_ht | tva(lot.sale_price_less_parking) | prettyPrice}} %)</i>
                      </span>
                    </span>
                  </span>
                </div>
                <div class="has-text-weight-medium" v-if="lot.sale_price_less_parking">
                  <span class="has-text-black">Prix immo (hors parking) TTC :
                    <span class="has-text-grey"><span>{{lot.sale_price_less_parking | prettyPrice}} {{$currency}}</span></span>
                  </span>
                </div>
                <div class="has-text-weight-medium" v-if="lot.capped_profitability">
                  <span class="has-text-black">Rentabilité plafonné :
                    <span class="has-text-grey"><span>{{lot.capped_profitability | prettyPrice}} %</span></span>
                  </span>
                </div>
                <div class="has-text-weight-medium" v-if="lot.capped_rent">
                  <span class="has-text-black">Loyer plafonné :
                    <span class="has-text-grey">
                      <span>{{lot.capped_rent | prettyPrice }} {{$currency}}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="is-margin-left-large is-margin-right-large is-margin-top is-margin-bottom">
              <div class="field is-grouped">
                <div class="control is-expanded" v-if="lotsList && lotsList.length">
                  <a v-scroll-to="'#lots'"
                     class="button is-small is-black is-rounded is-transform-none is-padding-left-large is-padding-right-large is-min-width-0 is-fullwidth">
                    Les autres lots du programme
                  </a>
                </div>
                <div class="control is-expanded" v-if="brochure && brochure.path">
                  <a target="_blank" :href="brochure.path" :download="brochure.filename"
                     class="button is-small is-grey is-outlined is-rounded is-transform-none is-padding-left-large is-padding-right-large is-min-width-0 is-fullwidth">
                    <span class="icon is-small"><i class="fas fa-book-open"></i></span><span>Brochure programme</span>
                  </a>
                </div>
                <div class="control is-expanded" v-if="reservation && reservation.path">
                  <a target="_blank" :href="reservation.path" :download="reservation.filename"
                     class="button is-small is-grey is-outlined is-rounded is-transform-none is-padding-left-large is-padding-right-large is-min-width-0 is-fullwidth">
                    <span class="icon is-small"><i class="fas fa-file-signature"></i></span><span>Dossier réservation</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="has-bg-white is-border is-margin-top-large" id="documents">
            <div class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active' : panel === 'PLAN'}" style="max-width: 50%">
                  <a @click="changePanel(PANELS.PLAN)">Plan du lot</a>
                </li>
                <li :class="{'is-active' : panel === 'LOTDOCS'}" style="max-width: 50%"
                    v-if="(lot.documents && lot.documents.length) || (displayed_lot_documents_flux && displayed_lot_documents_flux.length)">
                  <a @click="changePanel(PANELS.LOTDOCS)">Documents du lot</a>
                </li>
                <li :class="{'is-active' : panel === 'PROGDOCS'}" style="max-width: 50%"
                    v-if="(program && program.documents && program.documents.length) || (displayed_program_documents_flux && displayed_program_documents_flux.length)">
                  <a @click="changePanel(PANELS.PROGDOCS)">Documents du programme</a>
                </li>
              </ul>
            </div>
            <component :is="panelComponent"
                       v-if="program && lot"
                       :program="program"
                       :lot="lot"
            ></component>
          </div>

          <!-- <div class="has-bg-white is-border is-padding-top-xsmall is-padding-bottom-xsmall is-margin-top-large"
               v-if="program && program.location && program.location.latitude" id="mapVue">
            <div class="is-padding-top-xsmall is-padding-right-small is-padding-bottom-small is-padding-left-small">
              <div class="vue-map-container" style="width: 100%; background-color: white;">
                <div ref="map" style="width: 100%; height: 500px;"></div>
                <gmap-filter :source="program" :map="$refs.map"
                             v-if="program && $refs.map"
                             @poifilters="val => poiMarkers = val"></gmap-filter>
              </div>
            </div>
          </div> -->

          <div class="has-bg-light is-border is-padding-bottom-xsmall is-margin-top-large" id="lots"
               v-if="lots">
            <div class="is-padding has-bg-white is-border-bottom">
              <div class="title is-5 is-uppercase">Autre<span v-if="lots.length > 0">s</span> lot<span v-if="lots.length > 0">s</span> du programme {{program.name}}</div>
            </div>
            <div class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom has-bg-white">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active' : panelList === 'LOGEMENT'}" style="max-width: 50%">
                  <a @click="changeListPanel(PANELSLIST.LOGEMENT)">{{filteredLogement.length}} logement(s)</a>
                </li>
                <li :class="{'is-active' : panelList === 'PARKING'}" style="max-width: 50%">
                  <a @click="changeListPanel(PANELSLIST.PARKING)">{{filteredParking.length}} parking(s)</a>
                </li>
              </ul>
            </div>
            <stock-lots class="is-margin-bottom-large"
                        :from-card="true"
                        :source-lots="lotsList"
                        :params-list="paramsList"
                        @sort="sort"
                        :is-parking="panelList === 'PARKING'"
            ></stock-lots>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues, EventTrackerMx } from '@/mixins'
  import LotMixins from './LotMixins'
  import StockLots from '../stock/StockLots'

  export default {
    name: 'LotVue',
    data () {
      return {
        service: this.$api.lotService,
        fromOption: false
      }
    },
    mixins: [DefaultValues, EventTrackerMx, LotMixins],
    components: {
      StockLots
    },
    computed: {
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actabilité',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      },
      eventEntity () {
        return this.lot
      },
      lotPk () {
        return this.$route.params.id
      },
      events () {
        if (this.lot) {
          return this.lot.events
        } else {
          return []
        }
      }
    },
    watch: {
      lots (v) {
        window.setTimeout(() => {
          this.calcMinHeight()
        }, 200)
      }
    },
    methods: {
      getLot () {
        this.loading = true
        this.service.getOne(this.lotPk).then(res => {
          this.lot = res.data
          if (!this.lot.plan && this.lot.documents && this.lot.documents.length) {
            this.panel = this.PANELS.LOTDOCS
          }
          this.getProgram(res.data.program)
          this.getOptions()
          this.getLots(res.data.program)
          if (['sold', 'reserved'].includes(this.lot.status)) {
            this.getAdv()
          }
          if (this.isExternal) {
            this.getProgramAccess()
            this.getPromoteurAccess()
          }
          if (this.isAdmin) {
            this.getUsers()
            this.getUserInAccesses(1, res.data.program)
            this.getAllotment()
          }
          this.scrollToHash()
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.$router.replace({name: 'NotFound'})
        })
      },
      calcMinHeight () {
        // Calcul de la hauteur minimum pour que ds un fichier lot quand on passe de l'onglet "Lot" à "Parking" la hauteur de la page ne se réduise pas
        // Idem ds ProgramVue.vue
        let wraperEl = this.$el.querySelector('#lots')
        if (wraperEl === null || undefined) return true
        let wrapHeight = wraperEl.offsetHeight
        wraperEl.style.minHeight = wrapHeight + 'px'
      }
    },
    created () {
      if (this.$route.query.from === 'option') {
        this.fromOption = true
      }
    },
    mounted () {
      this.calcMinHeight()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotVue.vue